<template>
<v-dialog :fullscreen="$vuetify.breakpoint.mobile"
          :value="value" :style="{ borderRadius: '50px' }"
          scrollable max-width="80%"
          persistent>
  <v-card class="d-flex flex-column">
    <v-card-title class="primary white--text">
      {{getTitle}}
      <v-spacer/>
      <v-btn text elevation="0" color="white" small @click="$emit('input', false)">
        Fechar <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider/>
    <v-card-text class="py-4 flex-grow-1" 
      style="height: 80%;"
      v-if="value">

      <v-form ref="form" @submit.prevent="save" v-model="formValid" lazy-validation>
        <v-sheet class="resumo-inscricao pa-4 mb-4" outlined rounded>
          <div class="text-subtitle-2 font-weight-bold mb-3">Dados da inscrição</div>
          <v-row dense>
            <v-col cols="12" sm="6">
              <div class="resumo-item__label">Descrição do evento</div>
              <div class="resumo-item__valor">{{ item.descEventoEdicao || '-' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="resumo-item__label">Empresa inscrita</div>
              <div class="resumo-item__valor">{{ item.descTipoInscricao }}- {{ nomeEmpresaInscrita }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="resumo-item__label">Quem inscreveu a empresa</div>
              <div class="resumo-item__valor">{{ item.nomeContato }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="resumo-item__label">Data da inscrição</div>
              <div class="resumo-item__valor">{{ dataInscricao }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="resumo-item__label">Status</div>
              <div class="resumo-item__valor">{{ item.descStatus }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="resumo-item__label">Inscrição</div>
              <div class="resumo-item__valor">{{ item.descTipoAcessoEventoEdicao }}{{ infoPagamento }}</div>
            </v-col>
          </v-row>
        </v-sheet>
        <v-text-field
          v-model="item.linkPagamento"
          label="Link de pagamento"
          placeholder="Cole aqui o link de pagamento"
          outlined
          dense
          clearable
        />
      </v-form>

    </v-card-text>
    <v-divider/>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="success" @click="$emit('input', false)" :disabled="loading">Cancelar</v-btn>
      <v-btn color="primary" @click="save" :disabled="!formValid || loading">Enviar</v-btn>
    </v-card-actions>
  </v-card>
  <v-overlay :value="loading" absolute>
    <v-progress-circular
      indeterminate
      color="primary"
      class="ma-4"
    ></v-progress-circular>
  </v-overlay>    
</v-dialog>
</template>

<script>
import {enviarLinkPagamento} from "../../../api/eventoInscricao";
import {ApiError} from "../../../api/core";
import moment from 'moment';

export default {
  name: "EnviarLinkPagamentoDialog",
  components: {},
  props: ['value','item'],
  data () {
    return {
      formValid: false,
      loading: false,
    }
  },
  computed: {
    getTitle() {
      return 'Enviar Link de Pagamento';
    },
    dataInscricao() {
      if (!this.item?.dtInscricao) {
        return '-';
      }

      return moment(this.item.dtInscricao).format('DD/MM/YYYY');
    },
    nomeEmpresaInscrita() {
      return this.item?.nomeCompletoFornecedor || this.item?.nomeCompletoComprador || this.item?.inscrito || '-';
    },
    infoPagamento() {
      if (this.item?.tipoAcessoEventoEdicao === 'P') {
        return ` - Valor: R$ ${this.item.valorInscricaoEdicao}. ${this.item.linkPagamento === '' ? 'link de pagamento não enviado' : 'link de pagamento enviado por email'}`;
      }
      return '';
    },     
  },
  methods: {
    async save() {
      try {
        this.loading = true;
        if(this.$refs.form.validate()) {

          await enviarLinkPagamento(this.item.id, this.item);

          this.$emit('input', false);
          this.$emit('onSave');
          this.$toast.success(`Link de pagamento enviado com sucesso.`, {
            timeout: 3000
          })
        }
      } catch (err) {
        if(err instanceof ApiError) {
          this.$toast.error(err.message, {
           timeout: 6000
          })
        } else {
          this.$toast.error(`Não foi possível enviar o link de pagamento.`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
      }
    }
  },
}
</script>

<style scoped>

.resumo-inscricao {
  border-color: #dbe7f3 !important;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
}

.resumo-item__label {
  color: #54708c;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 2px;
}

.resumo-item__valor {
  color: #1f2d3d;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.4;
  word-break: break-word;
}

</style>